module.exports = __webpack_public_path__ + "static/media/icon-plus.5ee9f44b.svg";